import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import './styles/style.css'; // Custom CSS for slider
import { toast, ToastContainer } from 'react-toastify';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import ReactModal from 'react-modal';
import imageCompression from 'browser-image-compression';

function EditPersonalInfoSubscription() {

    const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

    const location = useLocation();
    const navigate = useNavigate();

    
    const queryClient = useQueryClient();

    const [message, setMessage] = useState('');
    
    const [profile, setProfile] = useState({
        
        phone_number: '',
        email: '',
        });


    const { data, isLoading, isError } = useQuery({
        queryKey: ['userProfileDetails'],
        queryFn: async () => {
          const res = await axios.get(`${API_URL}/profile-settings-api`, { withCredentials: true });
          return res.data;
        },
        staleTime: 0,
        cacheTime: Infinity
      });
      


     useEffect(() => {
        if (data) {
          if (data.Status === "Success") {
            const user = data.user;
      
            setProfile({
                
        phone_number: user.phone_number || '',
        email: user.email || '',
       
            });
          } else {
            setMessage("Failed to load user data");
          }
        }
      }, [data]);


    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile((prev) => ({
            ...prev,
            [name]: value
        }));
    };



  const [loading, setLoading] = useState(false);

  const handleProfileUpdate = async () => {

    if (!profile.phone_number && !profile.email) {
        toast.error("Please enter at least a phone number or an email.");
        return;
      }

    setLoading(true); // Disable the button
  
    const formData = new FormData();

    try {
      const response = await axios.put(
        `${API_URL}/edit-personal-info-subscription-api`,
        {
          phone_number: profile.phone_number,
          email: profile.email,
        },
        { withCredentials: true }
      );
      toast.success("Details updated successfully");
      navigate('/family-tree');
      
    } catch (error) {
      toast.error("Error updating details");
      console.error('Error updating details:', error);
    } finally {
      setLoading(false); // Re-enable the button
    }
  };

 


    return (
         
        <div className="scrollPageContainer theme-light">
            <div className="main-wrapper">

            {/*start of header*/}
         {isSidebarVisible && <Sidebar />}
         <Header toggleSidebar={toggleSidebar} />
         {/*end of header */}
         {/*start of sidebar*/}
         <Sidebar show={showSidebar} toggle={toggleSidebar} />
         {/*End of sidebar*/}
         {/* start of footerbar */}
         <Footerbar toggleSidebar={toggleSidebar} />
         {/* end of footerbar */}
        <ToastContainer />

         <div className="page-wrapper">
         <div className="content container-fluid">

            <div className="row mt-3">

            <div className="col-md-12">

            <div className="card">
                <div className="card-body">

          

                <div className="row">
                    <div className="col-12 col-md-12">
                  
                    <label className="control-label">Your Phone Number</label>
                    <input type="text" name="phone_number" value={profile.phone_number} onChange={handleChange} placeholder="Phone Number" className="form-control mb-2" />
                   
                    </div>
                    
                </div>

                <div className="row">

                <div className="col-12 col-md-12">
                    <label className="control-label">Your Email</label>
                    <input type="email" name="email" value={profile.email} onChange={handleChange} placeholder="Email" className="form-control mb-2" />
                </div>

                    </div>

               
                <div className="row">
                    <div className="col-10 col-md-10">
                      
                   
                    <button type="submit" className="btn btn-primary"  onClick={handleProfileUpdate}
                    disabled={loading}>
                    {loading ? 'Updating...' : 'Update Information'}
                    </button>
                 
                    
                    </div>
                    <div className="col-2 col-md-2">
                    
                    </div>
                </div>




                </div>
                </div>

                

        

                </div>

            </div>


            <div className='row end-page-space' >  </div>

            </div>
            </div>
        
        </div>
        </div>
    );
}

export default EditPersonalInfoSubscription;
